import ExerciseStore from '../storage/ExerciseStore.js'
import WorkoutStore from '../storage/WorkoutStore.js'

class App extends HTMLElement {

  #refresh = () => {
    this.querySelector("gime-exercises-view").refresh()
    this.#updateStartButton()
  }

  #addExercise = (event) => {
    event.preventDefault()
    this.querySelector("gime-exercise-dialog").show()
  }

  #editExercise = (event) => {
    const exercise = ExerciseStore.get(event.detail.id)
    if (exercise) {
      this.querySelector("gime-exercise-dialog").showEdit(exercise)
    }
  }

  #startWorkout = (event) => {
    event.preventDefault()
    WorkoutStore.start()
    this.setAttribute("mode", "workout")
    this.querySelector("gime-workout-view").refresh()
  }

  #endWorkout = (event) => {
    event.preventDefault()
    WorkoutStore.end()
    this.removeAttribute("mode")
    this.querySelector("gime-exercises-view").refresh()
  }

  #updateStartButton = () => {
    const button = this.querySelector("[data-start-workout]")
    if (ExerciseStore.getAll().length > 0) {
      button.removeAttribute("disabled")
    }
    else {
      button.setAttribute("disabled", "")
    }
  }

  connectedCallback() {
    this.querySelector("gime-add-exercise button").addEventListener("click", this.#addExercise)
    this.querySelector("gime-exercise-dialog").addEventListener("gime-save", this.#refresh)
    this.addEventListener("gime-edit-exercise", this.#editExercise)
    this.addEventListener("gime-delete-exercise", this.#updateStartButton)
    this.querySelector("[data-start-workout]").addEventListener("click", this.#startWorkout)
    this.querySelector("[data-end-workout]").addEventListener("click", this.#endWorkout)

    if (WorkoutStore.isActive()) {
      this.setAttribute("mode", "workout")
    }

    this.#updateStartButton()
  }
}

export default App
